import { IMunicipality } from '@sky-it-elections/design-system/';

// API
export const getHeaders = (): Headers => {
  const headers: Headers = new Headers();

  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');

  // UNCOMMENT what's needed by CORS
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Access-Control-Allow-Methods', 'HEAD, GET, POST, OPTIONS');
  headers.append('Access-Control-Allow-Headers', 'Content-Type');
  // headers.append('Access-Control-Allow-Headers', 'Origin, Content-Type, X-Auth-Token');
  // headers.append('Access-Control-Allow-Headers', 'Content-Type, Authorization, X-Requested-With');
  headers.append('Access-Control-Max-Age', '86400');

  return headers;
};

export const getAsyncOptions = async (
  request: Request,
  setLoading: Function,
  setAsyncOptions: Function
): Promise<void> => {
  try {
    setLoading(true);
    const response: Response = await fetch(request); // FIXME: MOCK will be removed after 1st DEPLOY

    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }

    const result = (await response.json()) as Array<IMunicipality>;
    const suggestions: Array<IMunicipality> = result.sort((prev, next) => prev.name.localeCompare(next.name));
    // console.log('search-input-helpers', { request, response, result, suggestions });

    setLoading(false);
    setAsyncOptions(suggestions);
  } catch (error) {
    setLoading(false);
    if (error instanceof Error) {
      console.error('[search-input] error message: ', error.message); // eslint-disable-line no-console
    } else {
      console.error('[search-input] unexpected error: ', error); // eslint-disable-line no-console
    }
  }
};
